import { Box, Chip, FormControlLabel, Radio, Typography } from "@mui/material";
import { formatParticipantAddress } from "@shared";
import { participantTypeLabels } from "@shared";

import { ProceedingParticipantSearchResult } from "@/api";
import { useTranslation } from "@/translations";

interface Props {
  participant: ProceedingParticipantSearchResult;
  isDestination: boolean;
}

export function MergeDestinationOption({ participant, isDestination }: Props) {
  const { t } = useTranslation();
  const address = formatParticipantAddress(
    participant.street,
    participant.houseNumber,
    participant.zipCode,
    participant.city
  );

  return (
    <FormControlLabel
      value={participant.proceedingParticipantId}
      control={<Radio />}
      label={
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2 }}>
          <Box>
            <Typography variant="body1" fontWeight={600}>
              {participant.name}
            </Typography>
            {address && (
              <Typography variant="body2" color="text.secondary">
                {address}
              </Typography>
            )}
            <Typography variant="body2" color="text.secondary">
              {participantTypeLabels(t)[participant.type]}
            </Typography>
          </Box>
          {isDestination && <Chip label={t("proceedingParticipants.merge.existsBadge")} size="small" color="primary" />}
        </Box>
      }
      sx={(theme) => ({
        m: 0,
        p: 2,
        gap: 1,
        border: 1,
        borderRadius: 1,
        borderColor: isDestination ? theme.palette.primary.main : theme.palette.divider,
        backgroundColor: isDestination ? "action.selected" : "transparent",
        "& .MuiFormControlLabel-label": { flex: 1 },
      })}
    />
  );
}
